export class RouteConstant {
  static readonly AuthLogin = "/auth/login";
  static readonly USERS_PROFILE = "/study/profile";
  static readonly RadiologistProfile = "/study/radiologist-profile";
  static readonly USERS_2FA_VERIFY = "/users/2faauth-verify";
  static readonly AuthSignupHospital = "/auth/signup-hospital";
  static readonly AuthOAUTH = "/auth/oauth";
  static readonly StudyOrder = "/study/order";
  static readonly Dashboard = "/dashbaord";
  static readonly ThankYou = "/auth/thank-you";
  static readonly USER_ACTIVITY_LOG = "/logs";
  static readonly USER_PROFILE_ACTIVITY_LOG = "/user-activity/log";
  static readonly UpdateProfile = "/study/update-profile";
}
